import React from "react";
import AdminPlaceholder from "@/components/site/PortalPlaceholder";

export default function AlignerTracking() {
    return (
        <AdminPlaceholder
            eyebrow="Tracking / Aligner tracking"
            title="Aligner tracking"
            description="Monitor every patient's progress through their aligner sequence. From the day they receive the kit to the final retainer handover."
            bullets={[
                "List view: all approved/shipped cases, with current_aligner_stage / plan total",
                "Progress bar per patient, color-coded by on-track / lagging / stalled",
                "Filters: clinic, doctor, complexity, days since last stage update",
                "Reminder triggers: nudge patient or doctor when a stage is overdue",
                "Reuses the same data the doctor sees in the Case panel's Track aligners widget",
            ]}
            wave="Wave 3"
            primaryCta="Doctor view of aligner tracking (live)"
            primaryCtaTo="/admin/patients"
            note="The doctor-side Track aligners widget is already shipped on the Case panel. This admin list view aggregates that data across all patients."
        />
    );
}
